var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCohere(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4254_4220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5777 6.34375H6.12012V23.8013H23.5777V6.34375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4254_4220)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7768 16.739C12.2466 16.739 13.1819 16.7138 14.4729 16.1817C15.9789 15.5621 18.9744 14.4371 21.134 13.281C22.6459 12.4732 23.3069 11.403 23.3069 9.9638C23.3069 7.96577 21.6869 6.3457 19.6889 6.3457H11.3158C8.44474 6.3457 6.11914 8.67279 6.11914 11.5424C6.11914 14.4119 8.29948 16.739 11.7768 16.739Z",
    fill: "#3A594D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1934 20.3168C13.1934 18.9101 14.0397 17.6414 15.3396 17.1018L17.9765 16.008C20.643 14.9007 23.5793 16.8617 23.5793 19.7491C23.5793 21.9857 21.765 23.8 19.5284 23.7985H16.6736C14.7512 23.797 13.1934 22.2392 13.1934 20.3168Z",
    fill: "#BD8FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11763 17.4238C7.46348 17.4238 6.12207 18.7652 6.12207 20.4194V20.8077C6.12207 22.4619 7.46348 23.8033 9.11763 23.8033C10.7718 23.8033 12.1132 22.4619 12.1132 20.8077V20.4194C12.1132 18.7652 10.7718 17.4238 9.11763 17.4238Z",
    fill: "#EE765C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohere);
export default __webpack_public_path__ + "static/media/Cohere.c79e2b0c96206547e558d59ca9b65303.svg";
export { ForwardRef as ReactComponent };